import { Dialog } from '@angular/cdk/dialog';

import { afterNextRender, inject, Injectable, NgZone, DOCUMENT } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter, map, merge, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UserActivityListenerService {
  private readonly document = inject(DOCUMENT);
  private readonly ngZone = inject(NgZone);
  private readonly router = inject(Router);
  private readonly dialog = inject(Dialog);
  public readonly userActivitySubject = new Subject<string>();

  start() {
    afterNextRender(() => {
      merge(
        // open dialog log
        this.dialog.afterOpened.pipe(map((dialogRef) => ({ type: 'openDialog' }))),
        // close dialog log
        this.dialog.afterAllClosed.pipe(map(() => ({ type: 'closeDialog' }))),
        // router change log
        this.router.events.pipe(
          filter((e): e is NavigationEnd => e instanceof NavigationEnd),
          map((routerData) => ({ type: 'routerChange', text: routerData['url'] })),
        ),
      ).subscribe((res) => this.userActivitySubject.next(res.type));

      this.ngZone.runOutsideAngular(() => {
        // listen on click events
        this.document.addEventListener('click', (event) => {
          this.userActivitySubject.next('clicked')
        }, true);

        // listen on input change events
        this.document.addEventListener('change', (event) => {
          const target = event.target as HTMLElement;

          if (target.tagName === 'INPUT') {
            this.userActivitySubject.next('input changed')
          }
          if (target.tagName === 'TEXTAREA') {
            this.userActivitySubject.next('textarea changed')
          }
          // ... other elements

        }, true);
      });
    })
  }
}
